import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Heading from "@amzn/meridian/heading";
import Icon from "@amzn/meridian/icon";
import Modal from "@amzn/meridian/modal";
import Responsive from "@amzn/meridian/responsive";
import Row from "@amzn/meridian/row";
import Sheet from "@amzn/meridian/sheet";
import Text from "@amzn/meridian/text";
import closeSmallTokens from "@amzn/meridian-tokens/base/icon/close-small";
import { observer } from "mobx-react-lite";
import React from "react";

import AlertIcon from "../assests/Icons/AlertIcon";
import { FooterButton, FooterModalData } from "../constants/Footer";
import { ScreenSize } from "../constants/ScreenSize";
import { commonUnityStore } from "../store/CommonUnityStore";
import { IFooterModalList, IFooterModalProps } from "../types/Footer.types";

const DiscardModal = ({ handleResetChanges, isNormalTheme }: IFooterModalProps) => {
  const { handleChangeDiscardModal, isDiscardModal } = commonUnityStore;

  const confirmDiscardChangesHandler = () => {
    handleResetChanges();
    handleChangeDiscardModal(false);
  };

  const { STAY_ON_PAGE, UNSAVED_CHANGES, DISCARD_CHANGES_CONTENT } =
    FooterModalData;
  const { DEFAULT_DISCARD_CHANGES } = FooterButton;

  const footerModalList: IFooterModalList[] = [
    {
      name: DEFAULT_DISCARD_CHANGES,
      onClick: confirmDiscardChangesHandler,
      type: "secondary"
    },
    {
      name: STAY_ON_PAGE,
      onClick: () => handleChangeDiscardModal(false),
      type: isNormalTheme ? "tertiary" : "primary"
    },
  ];

  const footerModalContent = (showMobileView: boolean) => {
    return (
      <>
        {showMobileView && (
          <Row alignmentHorizontal="end" width="100%" data-testid="discardmodal-close-row">
            <Button onClick={() => handleChangeDiscardModal(false)} type="icon" data-testid="discardmodal-close-button">
              <Icon tokens={closeSmallTokens} data-testid="discardmodal-close-icon"></Icon>
            </Button>
          </Row>
        )}
        <Column
          width={showMobileView ? "100%" : "352px"}
          alignmentHorizontal="center"
          alignmentVertical="center"
          spacingInset={showMobileView ? "400" : "400 none 400 500"}
          data-testid="discardmodal-content-column"
        >
          <AlertIcon />
          <Heading level={6} data-testid="discardmodal-title-heading">{UNSAVED_CHANGES}</Heading>
          <Text type="b200" alignment="center" data-testid="discardmodal-content-text">
            {DISCARD_CHANGES_CONTENT}
          </Text>

          <Row
            width="100%"
            alignmentHorizontal="center"
            alignmentVertical="center"
            data-testid="discardmodal-buttons-row"
          >
            {footerModalList.map(({ name, onClick, type }: IFooterModalList) => (
              <Button
                key={name}
                onClick={onClick}
                minWidth="50%"
                type={type}
                data-testid={`discardmodal-${name.toLowerCase().replace(/\s+/g, "-")}-button`}
              >
                {name}
              </Button>
            ))}
          </Row>
        </Column>
      </>
    );
  };

  return (
    <Responsive
      query="max-width"
      props={{
        showMobileView: {
          default: false,
          [ScreenSize._720]: true,
        },
      }}
    >
      {({ showMobileView }) =>
        !showMobileView ? (
          <Modal
            data-testid="discardmodal-desktop-modal"
            open={isDiscardModal}
            onClose={() => handleChangeDiscardModal(false)}
            scrollContainer="viewport"
            closeLabel="Close"
            aria-describedby="modal-description"
            bodySpacingInset="none"
          >
            {footerModalContent(showMobileView)}
          </Modal>
        ) : (
          <Sheet
            data-testid="discardmodal-mobile-sheet"
            type="overlay"
            side="bottom"
            open={isDiscardModal}
            onClose={() => handleChangeDiscardModal(false)}
          >
            {footerModalContent(showMobileView)}
          </Sheet>
        )
      }
    </Responsive>
  );
};
export default observer(DiscardModal);
